import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
// UI
import Toggle from 'material-ui/Toggle';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ActionEvent from 'material-ui/svg-icons/action/event';
import ActionSchedule from 'material-ui/svg-icons/action/schedule';
// momentjs
import moment from 'moment';
//
import modernEnvironment from '../../lib/RelayUtils';
import * as StreamAddMutation from '../../mutations/StreamAddMutation';
import * as StreamEditMutation from '../../mutations/StreamEditMutation';
//
import PopupGallery from '../media/PopupGallery';
import Icon from '../ui/icon/icon';
// components
import Rars from '../rars/Rars';
import TopicSelector from '../TopicSelector';
import ArticleSelector from '../articles/ArticleSelector';
import TextCharCount from '../ui/charCounter';
import { DefaultButton } from '../controls/button';
import Player from '../player/Player';
import StreamStatus from './StreamStatus';
import { preserveDate } from '../../lib/DateUtils';
// Preview
import Preview from '../preview/Preview';
//
import updateMediaFile from '../media/updateMediaFile';
// style
import '../ui/date-column.css';
import dateTimeStyle from '../ui/date-time-style';
import '../ui/button.css';
import buttonStyle from '../ui/button';
import '../ui/form.css';
import './stream-style.css';
import { styles, formElement, paperStyle, colors, containerHeader } from '../../lib/styles';

// locale
import('moment/locale/ru');

type Props = {
    stream: Object,
    location: Object,
    relay: Object,
    history: {
        replace: Function,
    },
    viewer: Object,
};

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const VideoPlayer = (url) => {
    if (url.data === null || url.data === '') {
        return (
            <div />
        );
    }
    let type = '';
    if (url.data.indexOf('.m3u8') === -1) {
        type = 'video/mp4';
    }
    const config = {
        sources: [{ src: url.data, type }],
        autoplay: false,
    };
    return (
        <div style={{ position: 'relative' }}>
            {url.screen && <div className="stream--player">Внимание, включена заставка!</div>}
            <Player
                style={{
                    width: 806,
                    height: 451,
                }}
                config={config}
            />
        </div>
    );
};

class Stream extends React.Component<Props> {
    constructor(props) {
        super(props);

        const stream = props.stream || {};
        this.state = {
            state: stream.state || (stream.active ? 'on_air' : 'draft'),
            active: stream.state === 'on_air',
            topics: stream.topics || [],
            title: stream.title || '',
            description: stream.description || '',
            errorTitleText: '',
            errorDescriptionText: '',
            video: stream.videoFile ? stream.videoFile.filename : '',
            videoFile: stream.videoFile ? stream.videoFile.id : '',
            screen: stream.screen || false,
            rating: stream.rating || '',
            ratingActive: Boolean(stream.rating),
            linkedArticles: stream.linkedArticles || [],
            availableAt: stream.availableAt ? new Date(stream.availableAt) : new Date(),
            galleryType: ['image'],
            preview: stream.preview ? stream.preview.filename : '',
            previewFile: stream.preview ? stream.preview.id : '',
            isPreview: false,
        };
    }

    componentDidMount = () => {
        if (this.state.active && this.props.location.insertItem) {
            this.setState({ video: this.props.location.insertItem.filename });
        }
    };

    showError = (state: Object): boolean => {
        const errorText = 'это поле нужно заполнить';
        const errorTitle = state.title && state.title.length ? null : errorText;
        const errorDesc = state.description && state.description.length ? null : errorText;
        if (errorTitle) {
            this.setState({
                errorTitleText: errorTitle,
            });
        }
        if (errorDesc) {
            this.setState({
                errorDescriptionText: errorDesc,
            });
        }
        return Boolean(errorDesc !== null || errorTitle !== null);
    };

    save = () => {
        if (this.showError(this.state)) {
            return;
        }
        const baseParams = {
            title: this.state.title,
            description: this.state.description,
            topics: this.state.topics.map(topic => topic.id),
            videoFile: this.state.videoFile,
            preview: this.state.previewFile,
            screen: this.state.screen,
            rating: this.state.rating,
            video: '',
            state: this.state.state,
            linkedArticles: this.state.linkedArticles.map(article => article.id),
            availableAt: this.state.availableAt.toISOString() || new Date(),
        };

        if (this.state.state !== 'on_air') {
            baseParams.videoFile = this.state.video.indexOf('.m3u8') === -1 ? this.state.videoFile : '';
            if (baseParams.videoFile) {
                const updateDataForMediaFile = {
                    title: baseParams.title,
                    description: baseParams.description,
                    topics: this.state.topics,
                };
                updateMediaFile(baseParams.videoFile, updateDataForMediaFile);
            }
        }

        if (baseParams.description === '' || baseParams.title === '') {
            return;
        }

        const { stream } = this.props;
        if (stream) {
            const params = {
                id: stream.id,
                ...baseParams,
            };
            StreamEditMutation.commit(this.props.relay.environment, params, () => {});
        } else {
            StreamAddMutation.commit(modernEnvironment, baseParams, (error, streamId) => {
                this.props.history.replace(`/stream/${streamId}`);
            });
        }
    };

    inputFieldEvent = (field, value) => {
        const setField = {};
        const key = `error${capitalizeFirstLetter(field)}Text`;
        const errorField = {};

        setField[field] = value;
        this.setState(setField);

        errorField[key] = (value === null || value.length === 0) ? 'это поле нужно заполнить' : '';
        this.setState(errorField);

        return (value === null || value.length === 0);
    };

    openDatePicker = (ref) => {
        this.refs[ref].openDialog();
    };

    renderArticles = () => (
        <div style={{ width: '100%' }}>
            <small style={{ ...formElement.smallTitle, marginBottom: -15 }}>Связанные новости</small>
            <ArticleSelector
                viewer={this.props.viewer}
                value={this.state.linkedArticles}
                onChange={v => this.setState({ linkedArticles: v })}
                hint=" "
            />
        </div>
    );

    renderStreamSource = () => {
        const streamUrls = this.props.viewer.streamUrls.mediaFiles || [];
        return streamUrls.map(item => (
            <Toggle
                key={item.id}
                labelStyle={{
                    color: '#2f1a45',
                    fontSize: 14,
                }}
                style={{
                    margin: '7px 0',
                }}
                label={`${item.title} — ${item.filename}`}
                value={item.id}
                onToggle={(event, isInputChecked) => {
                    if (isInputChecked) {
                        this.setState({
                            videoFile: item.id,
                            video: item.filename,
                        });
                    } else {
                        this.setState({
                            videoFile: '',
                            video: '',
                        });
                    }
                }}
                toggled={item.filename === this.state.video}
            />
        ));
    };

    renderDate = (flag) => {
        const timePickerStyle = {
            width: '100px',
        };
        const title = flag ? 'Дата и время начала стрима' : 'Дата выходы';
        return (
            <div style={{ marginTop: -2 }}>
                <small style={{ ...formElement.smallTitle, marginBottom: -46 }}>{title}</small>
                <div style={{ display: 'flex' }}>
                    <div className="date-column__long">
                        <DatePicker
                            textFieldStyle={dateTimeStyle.datePicker}
                            floatingLabelStyle={formElement.label}
                            underlineStyle={formElement.underLineStyle}
                            autoOk
                            ref="dp"
                            className="date-field"
                            floatingLabelText=""
                            value={this.state.availableAt}
                            formatDate={date => moment(date).format('DD MMMM YYYY')}
                            onChange={(e, d) => this.setState({ availableAt: preserveDate(this.state.availableAt, d) })}
                            name="DatePicker"
                        />
                        <IconButton
                            style={buttonStyle.icon}
                            onClick={() => this.openDatePicker('dp')}
                        >
                            <ActionEvent color={colors.link} />
                        </IconButton>
                    </div>
                    <div className="date-column__short">
                        <TimePicker
                            textFieldStyle={dateTimeStyle.timePickerField}
                            floatingLabelStyle={dateTimeStyle.timePickerLabel}
                            inputStyle={dateTimeStyle.timePickerInput}
                            underlineStyle={formElement.underLineStyle}
                            ref="dpts"
                            autoOk
                            format="24hr"
                            floatingLabelText="с"
                            value={this.state.availableAt}
                            onChange={(e, d) => this.setState({ availableAt: preserveDate(this.state.availableAt, d) })}
                            style={timePickerStyle}
                        />
                        <IconButton
                            style={buttonStyle.icon}
                            onClick={() => this.openDatePicker('dpts')}
                        >
                            <ActionSchedule color={colors.link} />
                        </IconButton>
                    </div>
                </div>
            </div>
        );
    };

    renderPreview = () => (
        <div style={{ marginTop: '17px' }}>
            <small style={{ ...formElement.smallTitle, marginBottom: 6 }}>Превью</small>
            {this.state.preview && <Preview
                item={this.state.preview}
                mediaId={this.state.previewFile}
                removePreview={() => {
                    this.setState({
                        preview: '',
                        previewFile: '',
                    });
                }}
            />}
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <ContentAdd />
                <IconButton
                    containerElement="label"
                    style={{ maxWidth: 12, height: 42, padding: 9 }}
                    className="btn__hover_empty"
                    onClick={() => {
                        this.setState({
                            openGallery: true,
                            galleryType: ['image'],
                            isPreview: true,
                        });
                    }}
                >
                    <Icon icon="video" />
                </IconButton>
            </div>
            <Divider />
        </div>
    );

    renderVideoInput = () => (
        <div style={{ marginTop: '17px' }}>
            <small style={{ ...formElement.smallTitle, marginBottom: 6 }}>Видео</small>
            {this.state.video && <Preview
                item={this.state.video}
                mediaId={this.state.videoFile}
                removePreview={() => {
                    this.setState({
                        video: '',
                        videoFile: '',
                        state: 'draft',
                    });
                }}
            />}
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <ContentAdd />
                <IconButton
                    containerElement="label"
                    style={{ maxWidth: 12, height: 42, padding: 9 }}
                    className="btn__hover_empty"
                    onClick={() => {
                        this.setState({
                            openGallery: true,
                            galleryType: ['video'],
                        });
                    }}
                >
                    <Icon icon="video" />
                </IconButton>
            </div>
            <Divider />
        </div>
    );

    renderRars = () => (
        <section style={{ display: 'flex' }}>
            <Rars
                style={{
                    width: 321,
                }}
                disabled={!this.state.ratingActive}
                value={this.state.rating}
                onChange={v => this.setState({ rating: v })}
            />
            <div style={{ margin: '41px 0 0 -45px' }}>
                <Toggle
                    label=""
                    toggled={this.state.ratingActive}
                    onToggle={(event, isInputChecked) => {
                        this.setState({
                            ratingActive: isInputChecked,
                        });
                        if (!isInputChecked) {
                            this.setState({ rating: '' });
                        }
                    }}
                />
            </div>
        </section>
    );

    render() {
        return (
            <section style={{ ...styles.twinPanes.wrapper, paddingBottom: 20, maxWidth: 845 }}>
                <Paper style={{ ...paperStyle.mainItem, paddingBottom: 200 }}>
                    <header style={containerHeader.header}>
                        <h3
                            style={{
                                ...styles.headerTitle,
                                ...styles.twinPanes.headerTitle,
                                marginTop: 25,
                                marginBottom: 15,
                            }}
                        >
                            Стрим
                        </h3>
                    </header>

                    <TextField
                        floatingLabelText="Название"
                        style={formElement.textField}
                        floatingLabelStyle={formElement.label}
                        inputStyle={formElement.textFieldInput}
                        value={this.state.title}
                        fullWidth
                        errorText={this.state.errorTitleText}
                        onChange={(e, v) => this.inputFieldEvent('title', v)}
                        floatingLabelFixed
                    />

                    <TextField
                        floatingLabelText="Описание"
                        style={formElement.textField}
                        floatingLabelStyle={formElement.label}
                        inputStyle={formElement.textFieldInput}
                        value={this.state.description}
                        fullWidth
                        multiLine
                        rows={1}
                        rowsMax={2}
                        maxLength="250"
                        errorText={this.state.errorDescriptionText}
                        onChange={(e, v) => this.inputFieldEvent('description', v)}
                        floatingLabelFixed
                    />
                    <TextCharCount
                        maxChar={250}
                        currentChar={this.state.description.length}
                    />

                    <PopupGallery
                        open={this.state.openGallery}
                        type={this.state.galleryType}
                        closeDialogHandle={() => {
                            this.setState({
                                openGallery: false,
                            });
                        }}
                        insertMediaFile={(item) => {
                            if (this.state.isPreview) {
                                this.setState({
                                    preview: item.filename,
                                    previewFile: item.id,
                                    openGallery: false,
                                    isPreview: false,
                                });
                            } else {
                                this.setState({
                                    video: item.filename,
                                    videoFile: item.id,
                                    openGallery: false,
                                });
                            }
                        }}
                    />

                    {this.renderPreview()}

                    {this.state.active &&
                    <section style={{ marginBottom: 35, marginTop: 25 }}>
                        <VideoPlayer data={this.state.video} screen={this.state.screen} />
                    </section>
                    }

                    {this.state.active &&
                    <section>
                        <small style={{ ...formElement.smallTitle, marginBottom: 26 }}>Потоки</small>
                        <Toggle
                            labelStyle={{
                                color: '#2f1a45',
                                fontSize: 14,
                            }}
                            style={{
                                margin: '7px 0',
                            }}
                            label="Заставка"
                            toggled={this.state.screen}
                            onToggle={(event, isInputChecked) => {
                                this.setState({ screen: isInputChecked });
                            }}
                        />
                        {this.renderStreamSource()}
                    </section>
                    }
                    {!this.state.active && this.renderVideoInput()}
                    <section className="stream--column-wrapper">
                        <div className="stream--column">
                            {this.renderDate(this.state.active)}
                            <div style={{ marginTop: 7 }}>{this.renderRars()}</div>
                        </div>
                        {!this.state.active &&
                        <div className="stream--column">
                            {this.renderArticles()}
                        </div>
                        }
                    </section>
                    {this.state.active &&
                    <section style={{ marginTop: 21 }}>
                        {this.renderRars()}
                        <div style={{ marginTop: 44, width: 320 }}>
                            {this.renderArticles()}
                        </div>
                    </section>
                    }
                </Paper>

                <div style={{ ...styles.sidebar.default, marginTop: 0 }}>
                    <div style={{ width: 267 }}>
                        <TopicSelector
                            viewer={this.props.viewer}
                            value={this.state.topics}
                            onChange={v => this.setState({ topics: v })}
                        />
                        <div className="button__bottom">
                            <StreamStatus
                                value={this.state.state}
                                onChange={(state) => {
                                    const video = state !== 'on_air' && this.state.video.indexOf('.m3u8') !== -1
                                        ? ''
                                        : this.state.video;
                                    this.setState({
                                        state,
                                        active: state === 'on_air',
                                        video,
                                    });
                                }}
                                published={Boolean(this.state.title.length
                                    && this.state.description
                                    && this.state.video
                                    && this.state.video.indexOf('.m3u8') === -1)}
                            />
                            <DefaultButton
                                onClick={this.save}
                            />
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(createFragmentContainer(
    Stream,
    graphql`
        fragment Stream_stream on Stream  {
            id,
            title,
            slug,
            video,
            state,
            topics {
                id,
                name
            },
            videoFile {
                id
                filename
                description
            },
            preview {
                id
                filename
            }
            screen,
            rating,
            active,
            linkedArticles {
                id,
                title,
            },
            description,
            availableAt
        },
    `,
));



// WEBPACK FOOTER //
// src/components/streams/Stream.js